<template>
  <!-- 组织机构 -->
  <div class="OrganizationWrap contentBox" ref="Organized">
    <router-link class="index-title" :to="{ path: '/organized', query:{ name: OrganizedName } }" target="_blank">{{ OrganizedName }}</router-link>
    <div class="content" ref="OrganizedContent">
      <div class="OrganizationBox" v-for="(item,index) in OrganizedData" :key="index">
        <div class="title">
          <p>{{item.name}}</p>
          <span @click="PackUpListFn(index)"></span>
        </div>
        <div class="name">
          <p v-for="(it,ind) in item.seminarNewsList" :key="ind">{{it.name}}</p>
        </div>
      </div>

      <!-- 新增 -->
      <div class="add-title-box"><a href="javascript:;" class="index-title">学术委员会</a></div>
      <div class="OrganizationBox add-box">
        <div class="title">
          <p>名誉主席</p>
          <span @click="PackUpListFn(OrganizedData.length + 1)"></span>
        </div>
        <div class="name">
          <p>孙　钧</p>
          <p>钱七虎</p>
        </div>
      </div>
      <div class="OrganizationBox add-box">
        <div class="title">
          <p>主席</p>
          <span @click="PackUpListFn(OrganizedData.length + 2)"></span>
        </div>
        <div class="name">
          <p>陈湘生</p>
          <p>周文波</p>
          <p>严金秀</p>
        </div>
      </div>
      <div class="OrganizationBox add-box">
        <div class="title">
          <p>顾问委员（按姓氏拼音首字母排序）</p>
          <span @click="PackUpListFn(OrganizedData.length + 3)"></span>
        </div>
        <div class="name">
          <p>陈湘生</p><p>陈祖煜</p><p>丁烈云</p><p>丁志诚</p><p>冯夏庭</p><p>葛修润</p><p>龚晓南</p><p>郭陕云</p><p>何满潮</p><p>李术才</p><p>李永盛</p><p>梁文灏</p><p>钱七虎</p><p>孙　钧</p><p>唐　忠</p><p>王复明</p><p>王振信</p><p>严金秀</p><p>杨华勇</p><p>杨国祥</p><p>周文波</p>
        </div>
      </div>
      <div class="OrganizationBox add-box">
        <div class="title">
          <p>学术委员（按姓氏拼音首字母排序）</p>
          <span @click="PackUpListFn(OrganizedData.length + 4)"></span>
        </div>
        <div class="name">
          <p>白　云</p>
          <p>毕湘利</p>
          <p>曹文宏</p>
          <p>陈　鸿</p>
          <p>陈　健</p>
          <p>陈建斌</p>
          <p>陈　馈</p>
          <p>陈立生</p>
          <p>程永亮</p>
          <p>戴振宇</p>
          <p>丁文其</p>
          <p>杜　峰</p>
          <p>何拥军</p>
          <p>洪开荣</p>
          <p>胡　珉</p>
          <p>胡　晓</p>
          <p>黄德中</p>
          <p>黄宏伟</p>
          <p>贾　坚</p>
          <p>贾连辉</p>
          <p>姜　弘</p>
          <p>李　波</p>
          <p>李耀良</p>
          <p>刘　斌</p>
          <p>刘千伟</p>
          <p>柳　献</p>
          <p>林家祥</p>
          <p>骆汉宾</p>
          <p>潘伟强</p>
          <p>裴烈烽</p>
          <p>仇文革</p>
          <p>沈国红</p>
          <p>沈庞勇</p>
          <p>孙　波</p>
          <p>滕　丽</p>
          <p>王杜娟</p>
          <p>王如路</p>
          <p>王卫东</p>
          <p>王秀志</p>
          <p>吴惠明</p>
          <p>吴煊鹏</p>
          <p>肖晓春</p>
          <p>肖明清</p>
          <p>徐正良</p>
          <p>姚占虎</p>
          <p>杨秀仁</p>
          <p>杨志豪</p>
          <p>杨国伟</p>
          <p>叶国强</p>
          <p>于　波</p>
          <p>袁大军</p>
          <p>袁　勇</p>
          <p>张　迪</p>
          <p>张冬梅</p>
          <p>张晋勋</p>
          <p>张孟喜</p>
          <p>张闵庆</p>
          <p>张中杰</p>
          <p>张忠海</p>
          <p>周　骏</p>
          <p>钟长平</p>
          <p>朱合华</p>
          <p>朱瑶宏</p>
          <p>朱雁飞</p>
          <p>竺维彬</p>
          <p>金井 诚（日本）</p>
          <p>水上 博之（日本）</p>
          <p>Alois Eisendle（奥地利）</p>
          <p>Anthony G Cohn（英）</p>
          <p>Tarcisio B. Celestino（巴西）</p>
          <p>Giuseppe Lunardi（意大利）</p>
        </div>
      </div>
      <div class="add-title-box"><a href="javascript:;" class="index-title">组织组委会</a></div>
      <div class="OrganizationBox add-box">
        <div class="title">
          <p>名誉主席</p>
          <span @click="PackUpListFn(OrganizedData.length + 6)"></span>
        </div>
        <div class="name">
          <p>李明安</p>
          <p>杨晓杰</p>
        </div>
      </div>
      <div class="OrganizationBox add-box">
        <div class="title">
          <p>主席</p>
          <span @click="PackUpListFn(OrganizedData.length + 7)"></span>
        </div>
        <div class="name">
          <p>李　波</p>
          <p>戴振宇</p>
        </div>
      </div>
      <div class="OrganizationBox add-box">
        <div class="title">
          <p>执行主席</p>
          <span @click="PackUpListFn(OrganizedData.length + 8)"></span>
        </div>
        <div class="name">
          <p>裴烈烽</p>
        </div>
      </div>
      <div class="OrganizationBox add-box">
        <div class="title">
          <p>执行副主席</p>
          <span @click="PackUpListFn(OrganizedData.length + 9)"></span>
        </div>
        <div class="name">
          <p>沈国红</p>
          <p>叶国强</p>
          <p>田　军</p>
          <p>朱雁飞</p>
          <p>温锁林</p>
          <p>滕　丽</p>
          <p>吴惠明</p>
          <p>包小华</p>
          <p>刘　斌</p>
        </div>
      </div>
      <div class="OrganizationBox add-box">
        <div class="title">
          <p>委员</p>
          <span @click="PackUpListFn(OrganizedData.length + 10)"></span>
        </div>
        <div class="name">
          <p>李　丹</p>
          <p>常　翔</p>
          <p>张冬梅</p>
          <p>吴洁晴</p>
          <p>吕建中</p>
          <p>龚　卫</p>
          <p>刘　健</p>
          <p>吕　炯</p>
          <p>丁治国</p>
          <p>陆　璐</p>
          <p>徐志玲</p>
          <p>肖晓春</p>
          <p>翟一欣</p>
          <p>吴兆宇</p>
          <p>马海鑫</p>
          <p>常　莹</p>
          <p>寿漪旺</p>
          <p>聂利超</p>
          <p>张　红</p>
          <p>张　琼</p>
          <p>彭崇梅</p>
          <p>孙凌晔</p>
          <p>崔　敉</p>
          <p>程　烨</p>
          <p>顾仁骏</p>
          <p>季豪杰</p>
          <p>金　毅</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default{
    name: 'IndexOrganizated',
    props: {
      OrganizedName: {
        type: String,
        default: '组织机构'
      },
      OrganizedData: {
        type: Array,
        default: () => []
      }
    },
    methods: {
      // 组织机构-收起
      PackUpListFn(ind) {
        let boxDom = this.$refs.OrganizedContent.children[ind];
        let contentDom = boxDom.children[1];
        let  height = contentDom.offsetHeight;
        boxDom.children[0].children[1].style.transform = (!!height) ? 'rotateX(180deg)' : 'rotateX(0deg)';
        if (!!height) {
          contentDom.style.height = height + 'px';
          let f = document.body.offsetHeight; //强制相应dom重绘，使最新的样式得到应用
          contentDom.style.height = '0px';
        } else {
          contentDom.style.height = 'auto';
          height = contentDom.offsetHeight;
          contentDom.style.height = '0';
          let f = document.body.offsetHeight;
          contentDom.style.height = height + 'px';
        }
      }
    }
  }
</script>

<style scoped>
  @media screen and (min-width: 1029px) {
    .OrganizationWrap .content {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }

    .OrganizationBox {
      width: 90%;
      border-radius: 5px;
      background: rgba(0, 0, 0, .3);
      color: #FFFFFF;
      padding: 13px 30px;
      margin-bottom: 10px;
      overflow: hidden;
    }

    /* .add-title-box .index-title::after {
      margin-top: 10px !important;
    } */

    .Organized .index-title{
      font-size: 40px;
      width: 90%;
    }

    .Organized .OrganizationWrap>a{
      display: block;
      margin: 0 auto 15px;
    }

    .Organized .add-title-box{
      display: flex;
      justify-content: center;
    }

    .add-title-box .index-title{
      cursor: default;
    }

    .add-title-box{
      width: 100%;
      margin-bottom: 15px;
    }

    .OrganizationBox .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 10px;
    }

    .OrganizationBox .title span {
      display: none;
    }

    .packup {
      max-height: 0;
      overflow: hidden;
      transition: max-height 3s ease-in-out;
      -webkit-transform: max-height 3s ease-in-out;
    }

    .OrganizationBox .name {
      transition: height 1s;
      overflow: hidden;
      display: flex;
      flex-wrap: wrap;
    }

    .OrganizationBox .name p {
      font-size: 16px;
      line-height: 28px;
      margin-right: 15px;
    }
  }
  @media screen and (min-width: 320px) and (max-width: 1024px) {
    .OrganizationBox {
      width: 100%;
      border-radius: 5px;
      background: rgba(0, 0, 0, .3);
      color: #FFFFFF;
      padding: .16rem .3rem;
      margin-bottom: .2rem;
      overflow: hidden;
    }

    .OrganizationBox .title {
      font-size: .32rem;
      line-height: .48rem;
      margin-bottom: .2rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: bold;
    }

    .OrganizationBox .title span {
      display: inline-block;
      background: url(../assets/image/arrow_icon.png) no-repeat center center;
      background-size: .2rem .12rem;
      width: .4rem;
      height: .4rem;
    }

    .add-box .title{
      margin-bottom: 0;
    }

    .add-box .name{
      margin-bottom: .2rem;
    }

    .add-title-box .index-title{
      padding: 0 !important;
    }

    .Organized .OrganizationWrap>a{
      color: #000000 !important;
    }

    .add-title-box,.Organized .OrganizationWrap>a{
      font-size: .56rem;
      font-weight: normal;
      font-stretch: normal;
      color: #ffffff;
      margin-bottom: .2rem;
      display: block;
    }

    .packup {
      max-height: 0;
      overflow: hidden;
      transition: max-height 3s ease-in-out;
      -webkit-transform: max-height 3s ease-in-out;
    }

    .OrganizationBox .name {
      transition: height 1s;
      overflow: hidden;
      display: flex;
      flex-wrap: wrap;
    }

    .OrganizationBox .name p {
      font-size: .28rem;
      line-height: .48rem;
      margin-right: .2rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/IndexOrganizated.vue